import Icon from '../components/Icon.vue'

Icon.register({
  'pencil-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8c4.7-4.7 12.3-4.7 17.1 0l111 111c4.7 4.7 4.7 12.3 0 17l-262.6 262.6-121.5 21.3c-16.4 2.8-30.7-11.4-27.8-27.8l21.2-121.5zM124.1 339.9c5.5 5.5 14.3 5.5 19.8 0l154-154c5.5-5.5 5.5-14.3 0-19.8s-14.3-5.5-19.8 0l-154 154c-5.5 5.5-5.5 14.3 0 19.8zM88 424v-48h-36.3l-11.3 64.5 31.1 31.1 64.5-11.3v-36.3h-48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pencil-alt.js
// module id = 1623
// module chunks = 0